import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'components';
import NotificationsTrigger from './components/NotificationsTrigger/NotificationsTrigger';
import NotificationsPopup from './components/NotificationsPopup/NotificationsPopup';

const Notifications = ({
  notifications,
  notificationItemAction,
  taskItemAction,
  notificationData,
  isNotificationsEmpty,
  onClickMarkAsRead,
  staticTexts,
  hasNewAlerts,
  onClickMarkAllAsRead,
}) =>
  <Dropdown
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    renderTrigger={({open, isOpen}) =>
      <NotificationsTrigger
        isOpen={isOpen}
        open={open}
        hasNewAlerts={hasNewAlerts}
      />
    }
    renderContent={({close}) =>
      <NotificationsPopup
        notifications={notifications}
        close={close}
        notificationItemAction={notificationItemAction}
        taskItemAction={taskItemAction}
        notificationData={notificationData}
        staticTexts={staticTexts}
        isNotificationsEmpty={isNotificationsEmpty}
        onClickMarkAsRead={onClickMarkAsRead}
        onClickMarkAllAsRead={onClickMarkAllAsRead}
      />
    }
  />;

Notifications.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      tag: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          createdAt: PropTypes.string,
          type: PropTypes.string,
          seen: PropTypes.bool,
          data: PropTypes.object,
        })
      )
    })
  ).isRequired,
  staticTexts: PropTypes.shape({
    markAsRead: PropTypes.string,
    markAsUnread: PropTypes.string,
    notificationsTitle: PropTypes.string,
    markAllAsRead: PropTypes.string,
    emptyStateMessage: PropTypes.string,
  }).isRequired,
  onClickMarkAsRead: PropTypes.func.isRequired,
  notificationItemAction: PropTypes.func.isRequired,
  taskItemAction: PropTypes.func,
  notificationData: PropTypes.shape({
    changedStatus: PropTypes.shape({
      requestStatusStaticText: PropTypes.string,
      messageStaticText: PropTypes.string,
    }),
    commentNotification: PropTypes.shape({
      replyStaticText: PropTypes.string,
      taggedStaticText: PropTypes.string
    }),
    requestSubmitted: PropTypes.shape({
      staticText: PropTypes.string
    }),

  }).isRequired,
  onClickMarkAllAsRead: PropTypes.func.isRequired,
  isNotificationsEmpty: PropTypes.bool,
  hasNewAlerts: PropTypes.bool,
};

Notifications.defaultProps = {
  isNotificationsEmpty: false,
  hasNewAlerts:false,
  taskItemAction: () => {},
};

export default Notifications;
